// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDV4O3emoAqGSLCyrhgZs-kiTJOs2I84tw",
  authDomain: "hi-bi-d94d9.firebaseapp.com",
  projectId: "hi-bi-d94d9",
  storageBucket: "hi-bi-d94d9.firebasestorage.app",
  messagingSenderId: "61234974175",
  appId: "1:61234974175:web:db577ab7c34217aad3c86a",
  measurementId: "G-XSK36HGYJY"
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);